

import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { SeoProvider } from '../../providers/seo.provider';
import { SpinnerProvider } from '../../components/spinner/spinner.provider';
import Swal from 'sweetalert2/dist/sweetalert2.js'


@Component({
  selector: 'component-presskit',
  templateUrl: './presskit.html',
  styleUrls: ['./presskit.scss']
})


export class PressKitPage {

  page: number = 1;
  totalPages: number;
  isLoaded: boolean = false;

  constructor(private router: Router, private seoProvider: SeoProvider, private spinner: SpinnerProvider) {
    seoProvider.setTitle("Angelcrypt | Press Kit");
  }

  showAlert(type) {
    if(type == 'audio') {
      Swal.fire({
        title: 'Angelcrypt - Audio',
        showClass: {
          popup: 'animate__animated animate__fadeIn'
        },
        icon: '',
        html:
        '<br /><b>Clockwork Blood Red</b><br /><audio controls src="https://storage.googleapis.com/angelcrypt-downloads/audio.02_Clockwork%20Blood%20Red.mp3"></audio>' +
        '<br /><br /><b>The Black Hand</b><br /><audio controls src="https://storage.googleapis.com/angelcrypt-downloads/audio.10_The%20Black%20Hand.mp3"></audio>' +
        '<br /><br /><b>Martyred Soul</b><br /><audio controls src="https://storage.googleapis.com/angelcrypt-downloads/audio.07_Martyred%20Soul.mp3"></audio>',
        showCloseButton: false,
        showCancelButton: false,
        showConfirmButton: false,
        focusConfirm: false,
      })
    }

    if(type == 'video') {
      Swal.fire({
        title: 'Angelcrypt - Video',
        showClass: {
          popup: 'animate__animated animate__fadeIn'
        },
        icon: '',
        html:
        '<br /><b>Promo Video</b><br /><video controls width="400"><source src="https://storage.googleapis.com/angelcrypt-downloads/Angelcrypt-promo.mp4" type="video/mp4"></video>' +
        '<br /><br /><b>Forever Hero</b><br /><video controls width="400"><source src="https://storage.googleapis.com/angelcrypt-downloads/Forever-hero.mp4" type="video/mp4"></video>',
        showCloseButton: false,
        showCancelButton: false,
        showConfirmButton: false,
        focusConfirm: false,
      })
    }

    if(type == 'logo') {
      Swal.fire({
        title: 'Angelcrypt - Logo & Emblem',
        showClass: {
          popup: 'animate__animated animate__fadeIn'
        },
        icon: '',
        html:
        '<br /><b>Logo</b><br /><img width="300px" src="https://storage.googleapis.com/angelcrypt-downloads/logo.png"></img>' +
        '<br /><br /><b>Emblem</b><br /><img width="300px" src="https://storage.googleapis.com/angelcrypt-downloads/emblem.png"></img>',
        showCloseButton: false,
        showCancelButton: false,
        showConfirmButton: false,
        focusConfirm: false,
      })
    }

    if(type == 'photo') {
      Swal.fire({
        title: 'Angelcrypt - Promo Photo',
        showClass: {
          popup: 'animate__animated animate__fadeIn'
        },
        icon: '',
        html:
        '<br /><b>With Logo</b><br /><a target="_blank" href="https://storage.googleapis.com/angelcrypt-downloads/promo-photo-1.jpg"><img width="300px" src="https://storage.googleapis.com/angelcrypt-downloads/promo-photo-1.jpg"></img></a>' +
        '<br /><br /><b>Without Logo</b><br /><a target="_blank" href="https://storage.googleapis.com/angelcrypt-downloads/promo-photo-2.jpg"><img width="300px" src="https://storage.googleapis.com/angelcrypt-downloads/promo-photo-2.jpg"></img></a>',
        showCloseButton: false,
        showCancelButton: false,
        showConfirmButton: false,
        focusConfirm: false,
      })
    }

    if(type == 'backdrop') {
      Swal.fire({
        title: 'Angelcrypt - Digital Backdrop',
        showClass: {
          popup: 'animate__animated animate__fadeIn'
        },
        icon: '',
        html:
        '<br /><b>Image Backdrop</b><br /><a href="https://storage.googleapis.com/angelcrypt-downloads/digital_backdrop.jpg" target="_blank"><div class="card"><img src="https://storage.googleapis.com/angelcrypt-downloads/digital_backdrop.jpg" /></div></a>' +
        '<br /><br /><b>Video Backdrop</b><br /><video controls width="400"><source src="https://storage.googleapis.com/angelcrypt-downloads/digital_backdrop.mp4" type="video/mp4"></video>',
        showCloseButton: false,
        showCancelButton: false,
        showConfirmButton: false,
        focusConfirm: false,
      })
    }
  }
}
